const o = (e = 0, r = Number.MAX_SAFE_INTEGER) => Math.floor(Math.random() * (r - e + 1)) + e, n = (e, r, t = "+ ") => e > r ? `${t}${r}` : `${e}`, u = (e) => e < 1e3 ? `${e}` : e < 1e6 ? `${Number((e / 1e3).toFixed(1))}k` : `${Number((e / 1e6).toFixed(1))}m`;
export {
  o as getRandomNumber,
  u as shortenNumber,
  n as toLimit
};
